<template>
  <section id="attachment-barcode-component">
    <div
      class="case-creation__step case-creation__test-information"
      v-loading="loading"
    >
      <el-row :gutter="20">
        <el-col :xl="24" :lg="24">
          <div class="case-creation__card attachments">
            <div
              class="case-creation__heading test-attacments border-bottom-none"
            >
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-attachments.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">E-requisition</h3>
              </div>
            </div>
            <div>
              <ul class="requisition-action-buttons">
                <li>
                  <router-link
                    :to="{
                      name: 'ErequisitionPrintData',
                      params: { order_id: this.$route.params.order_id },
                      query: { isColorPrint: false },
                    }"
                    target="_blank"
                  >
                    <el-button>
                      <img
                        src="@/assets/images/printer-icon-white.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                      Print
                    </el-button>
                  </router-link>
                </li>
                <li>
                  <el-button @click="onViewReq">
                    <img
                      src="@/assets/images/icons/actions/view-icon-white.svg"
                      alt=""
                      class="img-fluid icon"
                    />
                    VIEW
                  </el-button>
                </li>
                <li>
                  <el-button @click="downloadReport('false')">
                    <img
                      src="@/assets/images/icons/actions/download-new-white.svg"
                      alt=""
                      class="img-fluid icon"
                    />
                    DOWNLOAD
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("orders", [
      "getReport",
      "getDownloadReportStatus",
      "getCaseInformation",
    ]),
    ...mapGetters("errors", ["getError"]),
  },
  mounted() {},
  data() {
    return {
      reportUrl: "",
      loading: false,
    };
  },
  methods: {
    onViewReq() {
      let routerData = this.$router.resolve({
        name: "ErequisitionViewOrders",
        params: {
          order_id: this.$route.params.order_id,
        },
      });
      window.open(routerData.href, "_blank");
    },
    async downloadReport(status) {
      try {
        this.loading = true;
        let params = {
          download: true,
          orderId: this.$route.params.order_id,
          is_color_variant: status,
        };
        await this.$store.dispatch("orders/downloadRequisitionForm", params);
        if (this.getDownloadReportStatus) {
          sendNotification("Report Downloaded Successfully");
        } else {
          errorNotification("Error in downloading report");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    printPreview() {
      let id = this.$route.params.order_id;

      let routerData = this.$router.resolve({
        name: "ErequisitionPrintData",
        params: {
          order_id: id,
        },
        query: this.$route.query,
      });
      window.open(routerData.href, "_blank");
    },
    previewAutoFillReport() {
      let id = this.$route.params.order_id;

      let routerData = this.$router.resolve({
        name: "ErequisitionPreview",
        params: {
          order_id: id,
        },
        query: this.$route.query,
      });
      window.open(routerData.href, "_blank");
    },
  },
};
</script>
<style lang="scss">
#attachment-barcode-component {
  .requisition-action-buttons {
    display: flex;
    justify-content: flex-end;
    margin-right: 2px;
    margin-top: 1px;
    margin-right: 0px;

    li {
      &:not(:last-child) {
        margin-right: 15px;
      }

      .el-button {
        padding: 0 30px;
        background-color: #273480;
        color: #ffffff;
        min-height: 32px;
        line-height: 1;
        border: none;
        border-radius: 6px;
        text-align: center;
        margin: 2px;
        span {
          display: flex;
          align-items: center;
          img {
            width: 15px;
            margin-right: 5px;
          }
        }
      }
      &:nth-child(1) {
        .el-button {
          background: #4bb543;
        }
      }
    }
  }
  .el-dropdown-menu__item {
    padding: 0 10px;
    font-size: 12px;
  }
  iframe {
    ::-webkit-scrollbar {
      width: 10px;
      height: 5px;
    }

    ::-webkit-scrollbar-track {
      background-color: #ebebeb;
      -webkit-border-radius: 10px;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #6d6d6d;
      height: 10px;
    }
  }
}
.el-dropdown-menu {
  padding: 0;
  .el-dropdown-menu__item {
    padding: 0;
    a {
      color: #000;
      background: transparent;
    }
  }
  .download-option {
    color: #000;
    background: transparent;
    padding: 0 20px !important;
    &:hover {
      color: #000;
    }
  }
}
</style>
